import LineasPedidos from './lineaspedidosnew.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [{
        path: '/lineaspedidosnew/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('lineaspedidosnew', ['ADMIN', 'INSPECTOR'], LineasPedidos),
        keepAlive: true
    },
    {
        path: '/lineaspedidosnew/filter',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('lineaspedidosnew', ['ADMIN', 'INSPECTOR'], LineasPedidos, { searchOnInit: true }),
        keepAlive: false
    }
];
export default routes;